import type { AnimationType } from '@/hooks/useTemplateAnimation'
import type { ScoreBugPosition } from '@/services/jsonDataService'

export const POSITION_CLASSES: Record<ScoreBugPosition, string> = {
  top: 'scorebug-position--top',
  bottom: 'scorebug-position--bottom',
  'top-left': 'scorebug-position--top-left',
  'top-right': 'scorebug-position--top-right',
  'bottom-left': 'scorebug-position--bottom-left',
  'bottom-right': 'scorebug-position--bottom-right',
}

// Animation direction per position — enter slides in from nearest edge, exit reverses out
export const POSITION_ANIMATIONS: Record<ScoreBugPosition, { in: AnimationType; out: AnimationType }> = {
  top: { in: 'slideDown', out: 'slideUp' },
  'top-left': { in: 'slideDown', out: 'slideUp' },
  'top-right': { in: 'slideDown', out: 'slideUp' },
  bottom: { in: 'slideUp', out: 'slideDown' },
  'bottom-left': { in: 'slideUp', out: 'slideDown' },
  'bottom-right': { in: 'slideUp', out: 'slideDown' },
}
